import { Injectable } from '@angular/core';
import {
  CancelTrialRequest,
  CreateTrialRequest,
  GetTrialRequest,
  ListTrialRequest,
  ListTrialResponse,
  PartnerTrialApiService,
  TrialInterface,
} from '@vendasta/partner';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PartnerTrialServiceInterface } from './interfaces';

@Injectable({ providedIn: 'root' })
export class PartnerTrialService implements PartnerTrialServiceInterface {
  constructor(private api: PartnerTrialApiService) {}

  createTrial(partnerId: string, subscriptionTierId: string, start: Date, end: Date): Observable<boolean> {
    const req = new CreateTrialRequest({
      partnerId: partnerId,
      subscriptionTierId: subscriptionTierId,
      start: start,
      end: end,
    });
    return this.api.createTrial(req).pipe(map((res) => (res.status === 200 ? true : false)));
  }

  getTrial(partnerId: string): Observable<TrialInterface> {
    const req = new GetTrialRequest({ partnerId: partnerId });
    return this.api.getTrial(req).pipe(map((r) => r.trial || {}));
  }

  cancelTrial(partnerId: string, trialId: string): Observable<boolean> {
    const req = new CancelTrialRequest({ partnerId: partnerId, trialId: trialId });
    return this.api.cancelTrial(req).pipe(map((res) => (res.status === 200 ? true : false)));
  }

  listTrial(partnerId: string, pageSize: number, cursor: string): Observable<ListTrialResponse> {
    const req = new ListTrialRequest({ partnerId: partnerId, pageSize: pageSize, cursor: cursor });
    return this.api.listTrial(req);
  }
}
